import {LobbyImage} from '@colonist/types'
import {TranslationObject} from '@colonist/i18n'
import {createDivIn, createImgIn, createParagraphIn} from '../../ui_utils/DomUtils'

export interface ProgressBarData {
    current: number
    total: number
    label: TranslationObject
    showLockIcon?: boolean
}

export class UIProgressBarElement {
    private readonly container: HTMLDivElement

    constructor(parent: HTMLElement, data: ProgressBarData) {
        this.container = createDivIn(parent, 'mm-mode-card-bottom-row')
        this.render(data)
    }

    update(data: ProgressBarData) {
        this.container.replaceChildren()
        this.render(data)
    }

    private render(data: ProgressBarData) {
        if(data.showLockIcon) {
            createImgIn(this.container, LobbyImage.LockOn, 'mm-locked-progress-lock-icon')
        }

        const barContainer = createDivIn(this.container, 'mm-locked-progress-bar-wrapper')
        const bar = createDivIn(barContainer, 'mm-locked-progress-bar')
        const isEmpty = data.current == 0

        for(let i = 0; i < data.total; i++) {
            const segment = createDivIn(bar, i < data.current ? 'mm-progress-segment filled' : 'mm-progress-segment')
            segment.style.setProperty('--segment-index', i.toString())
            segment.style.setProperty('--total-segments', data.total.toString())
            if(isEmpty) segment.classList.add('empty-animated')
        }

        createParagraphIn(barContainer, data.label, 'mm-locked-progress-label')
    }
}
